import {QRMath} from './qr-math';

export class Polynomial {
    num: number[];

    constructor(num, shift) {
        if (num.length === undefined) {
            throw new Error(num.length + "/" + shift);
        }
        let offset = 0;
        while (offset < num.length && num[offset] === 0) {
            offset++;
        }
        this.num = new Array(num.length - offset + shift);
        for (let i = 0; i < num.length - offset; i++) {
            this.num[i] = num[i + offset];
        }
    }

    get(index: number) {
        return this.num[index];
    }

    getLength() {
        return this.num.length;
    }

    multiply(p: Polynomial): Polynomial {
        let num = new Array(this.getLength() + p.getLength() - 1);
        for (let i = 0; i < this.getLength(); i++) {
            for (let j = 0; j < p.getLength(); j++) {
                num[i + j] ^= QRMath.gexp(QRMath.glog(this.get(i)) + QRMath.glog(p.get(j)));
            }
        }
        return new Polynomial(num, 0);
    }

    mod(p: Polynomial): Polynomial {
        if (this.getLength() - p.getLength() < 0) {
            return this;
        }

        const ratio = QRMath.glog(this.get(0)) - QRMath.glog(p.get(0));
        const num = new Array(this.getLength());

        for (let i = 0; i < this.getLength(); i++) {
            num[i] = this.get(i);
        }
        for (let i = 0; i < p.getLength(); i++) {
            num[i] ^= QRMath.gexp(QRMath.glog(p.get(i)) + ratio);
        }
        return new Polynomial(num, 0).mod(p);
    }
}
